import { createSupabaseBrowserClient } from '@/lib/supabase/client';
import { getEnv } from '@/lib/env';
import { isTailnetHost } from '@/lib/ops/tailnet-host';
import type { OAuthProvider } from '@/lib/schemas/auth/oauth-provider.schema';

// Scopes par provider — surchargent les scopes par défaut de GoTrue.
//   • google : `profile` est nécessaire pour récupérer `picture` dans le ID
//     token (le défaut `openid email` ne suffit pas).
//   • azure  : `profile` apporte `name`, `User.Read` autorise l'appel Graph
//     ultérieur pour la photo (`/me/photo/$value`) — Microsoft ne renvoie
//     jamais la photo dans le ID token.
//   • linkedin_oidc : les scopes par défaut suffisent (`picture` déjà présent).
const PROVIDER_SCOPES: Partial<Record<OAuthProvider, string>> = {
  google: 'openid email profile',
  azure: 'openid email profile User.Read',
};

export async function signInOAuth(provider: OAuthProvider, redirectTo?: string) {
  const supabase = createSupabaseBrowserClient();
  const env = getEnv();
  const nextParam = redirectTo ? `?next=${encodeURIComponent(redirectTo)}` : '';
  // Depuis l'hôte Tailscale de l'observatoire des moteurs, le retour OAuth doit
  // revenir sur cet hôte (c'est là que vivent le code_verifier PKCE et la session) ;
  // GoTrue l'autorise via GOTRUE_URI_ALLOW_LIST (make observatory-enable).
  const origin = isTailnetHost(window.location.hostname)
    ? window.location.origin
    : env.NEXT_PUBLIC_APP_URL;
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: `${origin}/auth/callback${nextParam}`,
      scopes: PROVIDER_SCOPES[provider],
    },
  });
  if (error) throw error;
  return data;
}
